import { createActions } from 'redux-actions';

import { ActionRequest } from '@models/ActionRequest';
import { GetAllActionRequestParams, CreateActionRequestParams, UpdateActionRequestParams } from '@apis/ActionRequestApi';
import { Pagination } from '@models/Pagination';

export type State = {
  actionRequests?: ActionRequest[] | null;
  pagination?: Pagination;
  isLoading: boolean;
  isReload: boolean;
  isSuccess: boolean;
  serverErrors: object;
};

export type ActionRequestsFetchPayload = GetAllActionRequestParams;
export type ActionRequestCreatePayload = CreateActionRequestParams;
export type ActionRequestUpdatePayload = UpdateActionRequestParams;
export type StateUpdatePayload = Partial<State>;

export const {
  actionRequestsFetch,
  actionRequestCreate,
  actionRequestUpdate,
  stateUpdate,
  stateClear,
  stateReload,
} = createActions(
  'ACTION_REQUESTS_FETCH',
  'ACTION_REQUEST_CREATE',
  'ACTION_REQUEST_UPDATE',
  'STATE_UPDATE',
  'STATE_CLEAR',
  'STATE_RELOAD',
  {
    prefix: 'FEATURE_ACTION_REQUEST',
  },
);
